// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ smooth = false, selector }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    const el = selector ? document.querySelector(selector) : window;
    const opts = { top: 0, left: 0, behavior: smooth ? "smooth" : "auto" };
    el === window ? window.scrollTo(opts) : el.scrollTo(opts);
  }, [pathname, hash, smooth, selector]);

  return null;
}
